import './style/spinnerIcon.scss';
import {AwesomeIcon} from '@dvrd/dvr-controls';
import classNames from 'classnames';
import React from 'react';

interface Props {
    className?: string;
    spinning?: boolean;
}

export default function SpinnerIcon(props: Props) {
    const {className, spinning = true} = props;
    return (
        <AwesomeIcon name='arrows-rotate' className={classNames('spinner-icon', spinning && 'spinning', className)} />
    );
}
